import type { FC } from "react";
import BaseButton, { type BaseButtonProps } from "./BaseButton";
import variants from "./variants";

export type ButtonProps = BaseButtonProps & {
  intent?: "solid" | "outline" | "ghost";
  variant?: "primary" | "danger" | "warning" | "secondary";
  class?: string;
};

const Button: FC<ButtonProps> = ({
  intent = "solid",
  variant = "primary",
  className = "",
  disabled,
  leftIconProps,
  rightIconProps,
  ...props
}) => {
  const state = disabled ? "disabled" : "enabled";
  const buttonClassName = variants[variant][intent][state].button;
  const iconColor = variants[variant][intent][state].icon;

  return (
    <BaseButton
      className={`transition-all hover:opacity-95 active:scale-95 ${buttonClassName} ${className}`}
      disabled={disabled}
      leftIconProps={{
        color: iconColor,
        ...leftIconProps,
      }}
      rightIconProps={{
        color: iconColor,
        ...rightIconProps,
      }}
      {...props}
    />
  );
};

export default Button;
